module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "chc"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "as"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/as.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "fwd"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Text/fwd#fwd"
    }
  }, [_vm._v("Foreword by Brennan Manning")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "intro"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Text/intro#intro"
    }
  }, [_vm._v("Introduction: The Search for Simon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "part1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/part1#part1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Part One:")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter1#chapter1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 A Meeting on the Seashore "), _c('i', [_vm._v("John 1:40-43")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter2#chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Jesus the Fisherman "), _c('i', [_vm._v("Luke 5:1-11")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter3#chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 A Glimpse Inside His Household "), _c('i', [_vm._v("Luke 4:38-39")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter4#chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 The Fearless Water Walker "), _c('i', [_vm._v("Matthew 14:22-33")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter5#chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Who They Both Are "), _c('i', [_vm._v("Matthew 16:13-23")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter6#chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Loyal Despair "), _c('i', [_vm._v("John 6:53-71")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter7#chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 “Fear Not!” "), _c('i', [_vm._v("Mark 9:2-10")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter8#chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Back to Fishing "), _c('i', [_vm._v("Matthew 17:24-27")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter9#chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Confusion at the Final Meal "), _c('i', [_vm._v("John 13:6-10")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter10#chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Dismay in the Garden "), _c('i', [_vm._v("Mark 14:27-42")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter11#chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 The Despairing Denier "), _c('i', [_vm._v("Mark 14:66-72")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter12#chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 “. . . and Peter” "), _c('i', [_vm._v("Mark 16:7")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter13"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter13#chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 A Farewell on the Seashore "), _c('i', [_vm._v("John 21:1-23")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "part2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/part2#part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Part Two:")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIDGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter14"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter14#chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 The Passionate Preacher "), _c('i', [_vm._v("Acts 1—15")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter15"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter15#chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 The Compassionate Healer "), _c('i', [_vm._v("Acts 3:1-10; 9:32-42")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter16"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter16#chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 The Fearless Prisoner "), _c('i', [_vm._v("Acts 4:1-4; 5:18-20; 12:1-19")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter17"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter17#chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 The Reluctant Reconciler "), _c('i', [_vm._v("Acts 10:1-33")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "chapter18"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter18#chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 The Passionate Writer "), _c('i', [_vm._v("1-2 Peter")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "epi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/epi#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: The Faithful Martyr")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "bib"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "abt"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/abt#abt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a166910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/toc.vue
// module id = 63
// module chunks = 0